module.exports = __webpack_public_path__ + "fonts/GTAmericaMono-Medium.9d8704b8.woff2";